<template>
  <div class="store-groupbuy-card">
    <div
        class="store-groupbuy-card-branch"
        :style="!(photo && !isBranchError) && 'background-color: #E4E5EA;'"
    >
      <img
          :style="photoStyle"
          v-if="photo && !isBranchError"
          :src="photo"
          ref="branch"
          @load="branchOnLoad"
          @error="brandError"
      />
      <img
          src="./images/brand-empty.png"
          v-else
          class="brand-empty-img position-center"
      />
    </div>
    <div class="store-groupbuy-header-image position-top">
      <div class="store-groupbuy-header-site">
        <img
            v-if="!isLogoError && logo"
            :src="logo"
            class="store-groupbuy-header-img position-center"
            ref="logo"
            :style="logoStyle"
            @load="logoOnLoad"
            @error="logoError"
        />
        <div v-else class="store-groupbuy-header-img empty-logo position-center">
          <img
              src="./images/store-header-empty.png"
              alt=""
              class="store-groupbuy-header-empty position-center"
          />
        </div>
      </div>
    </div>
    <div class="store-groupbuy-name" v-text="storeName"/>
    <div class="business-scopes">
      <!--        v-if="detail && (detail.reviewScore && detail.reviewScore.value || detail.reviewScore)"-->
      <div
          class="business-scopes-item display-middle-flex"
      >
        <img
            src="./images/review-score.png"
            class="scopes-img display-middle-flex position-left"
        />
        <div class="scopes-text scopes-review display-middle-flex" v-text="detail && detail.score || '0.0'"/>
      </div>
      <div class="business-scopes-item display-middle-flex" v-if="detail && detail.perCapita">
        <div class="scopes-text display-middle-flex" v-text="perCapita"/>
      </div>
      <div class="business-scopes-item display-middle-flex">
        <div class="scopes-text float-right display-middle-flex" v-text="commercialDistrictName"/>
      </div>
      
          <div class="recommended-product">
            <div
                class="product-item display-middle"
                v-for="(m, i) in recommendedProduct"
                :key="'recommended-product-' + (i + 1)"
            >
            <!-- 微信打开app -->
              <WxOpenLaunchAppLocalV3
                :comId="`groupStore-lauch-btn-${m.code}`"
                :extinfoProps="getProWxRoute(m.code)"
                v-if="!!isWechat"
                :appid="wechatAppid"
                @click="wxClick"
                @launch-success="launchSuccess"
                @launch-error="launchError">
                  <div class="product-info"
                      :style="`background: url(${require('./images/box.png')}) no-repeat;background-size: 100% 100%;`">
                    <img :src="m.imagePath" class="product-image"/>
                    <div class="product-name overflow">
                      <span>{{ m.name }}</span>
                      <div class="product-price">
                        ${{ m.price || '0.00' }}
                        <span class="discount_price">${{ m.originalPrice || '0.00' }}</span>
                      </div>
                    </div>
                  </div>
              </WxOpenLaunchAppLocalV3>
              <!-- 非微信 -->
              <div v-if="!isWechat" @click="goApp(m.code)" class="product-info" :style="`background: url(${require('./images/box.png')}) no-repeat;background-size: 100% 100%;`">
                <img :src="m.imagePath" class="product-image"/>
                <div class="product-name overflow">
                  <span>{{ m.name }}</span>
                  <div class="product-price">
                    ${{ m.price || '0.00' }}
                    <span class="discount_price">${{ m.originalPrice || '0.00' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showDownSign" class="product-item display-middle">
              <div class="product-info" @click="loadMore">
                <div class="box_show_more"><img :src="require('../../images/down.png')"/></div>
              </div>
            </div>
          </div>
    </div>
    <transition name="slide-fade">
      <div class="masking" v-if="isShowMasking" @click="isShowMasking = false">
        <div class="masking-content">
          <div class="masking-tips-site">
            <div class="tips-row">
              <div class="round display-middle">1</div>
              <div class="display-middle tips-text">{{ maskingLang.one.one }}</div>
              <img class="display-middle blue-menu" :src="logoImgs.blueMenuImageSrc" />
              <div class="display-middle tips-text">{{ maskingLang.one.two }}</div>
            </div>
            <div class="tips-row">
              <div class="round display-middle">2</div>
              <div class="display-middle tips-text">{{ maskingLang.two.one }}</div>
              <div class="display-middle blue-button-site">
                <img class="display-middle blue-button" :src="logoImgs.blueButtonImageSrc">
                <img class="earth" :src="logoImgs.earthImageSrc" />
                <div class="tips-text earth-text">{{ maskingLang.two.two }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { queryStoreRecommendProduct } from '../../../../apis/gateway-web/store'
import WxOpenLaunchAppLocalV3 from "$common/components/wechat/wx-open-launch-app-local-v3";

import goappMixins from '../../mixins/goappMixins';
export default {
  mixins: [goappMixins],
  components: {WxOpenLaunchAppLocalV3},
  props: {
    detail: {
      type: Object
    },
    lang: {
      type: String
    }
  },
  data() {
    return {
      recommendList: [],
      pageSize: 2,
      default_img: 'https://fileserver.lifekh.com/files/app/M00/01/26/Cg76NWAFsHmANWehAAAdeZWCeSY224.png',
      photoStyle: '',
      logoStyle: '',
      isLogoError: false,
      isBranchError: false,
      isHaveMarketingType19: false,
      showDownSign: true
    };
  },
  watch: {
    logo(val, oldVal) {
      if (val && !oldVal) {
        this.isLogoError = false;
      }
    },
    photo(val, oldVal) {
      if (val && !oldVal) {
        this.isBranchError = false;
      }
    }
  },
  computed: {
    recommendedProduct() {
      const res = this.recommendList?.map(i => {
        if (!i?.imagePath) {
          i.imagePath = this.default_img
        }
        if (this.lang === 'zh') {
          return {
            ...i,
            name: i.name?.['zh-CN']
          }
        }
        if (this.lang === 'km') {
          return {
            ...i,
            name: i.name?.['km-KH']
          }
        }
        return {
          ...i,
          name: i.name?.['en-US']
        }
      })
      return res
    },
    photo() {
      return this?.detail?.photo ?? '';
    },
    logo() {
      return this?.detail?.logo ?? '';
    },
    perCapita() {
      if (this.lang === 'zh') {
        return `人均：$${this.detail?.perCapita}`
      }
      if (this.lang === 'km') {
        return `Per：$${this.detail?.perCapita}`
      }
      if (this.lang === 'km') {
        return `Per：$${this.detail?.perCapita}`
      }
    },
    commercialDistrictName() {
      if (this.lang === 'zh') {
        return this?.detail?.commercialDistrictName?.['zh-CN'] ?? '';
      }
      if (this.lang === 'km') {
        return this?.detail?.commercialDistrictName?.['km-KH'] ?? '';
      }
      return this?.detail?.commercialDistrictName?.['en-US'] ?? '';
    },
    ordered() {
      if (this.lang === 'zh') {
        return `已售 ${this?.detail?.ordered}`;
      }
      if (this.lang === 'km') {
        return `${this?.detail?.ordered} បានលក់`;
      }
      return `${this?.detail?.ordered} Sold`;
    },
    storeName() {
      if (this.lang === 'zh') {
        return this?.detail?.storeName['zh-CN'] ?? '';
      }
      if (this.lang === 'km') {
        return this?.detail?.storeName['km-KH'] ?? '';
      }
      return this?.detail?.storeName['en-US'] ?? '';
    }

  },
  mounted() {
    this.loadList();
  },
  methods: {
    async loadList() {
      const {
        rspCd,
        data
      } = await queryStoreRecommendProduct({
        pageSize: this.pageSize,
        pageNum: 1,
        storeNo: this.detail?.storeNo
      })
      if (rspCd + '' === '00000') {
        this.recommendList = data.list
        if (data.total <= this.recommendList.length) {
          this.showDownSign = false
        }
        this.$emit('setproduct',this.recommendList)
      }
    },
    brandError() {
      this.isBranchError = true;
    },
    logoError() {
      this.isLogoError = true;
    },
    logoOnLoad() {
      const __timeout = setTimeout(() => {
        clearTimeout(__timeout);
        const __width = this.$root.getWidth(this.$refs.logo);
        const __height = this.$root.getHeight(this.$refs.logo);
        this.logoStyle = `${__width > __height ? 'height: 100%;' : 'width: 100%;'}`;
      });
    },
    branchOnLoad() {
      const __timeout = setTimeout(() => {
        clearTimeout(__timeout);
        const __width = this.$root.getWidth(this.$refs.branch);
        const __height = this.$root.getHeight(this.$refs.branch);
        this.photoStyle = `${__width > __height ? 'height: 100%;' : 'width: 100%;'}`;
      });
    },
    getFirstOrderTitle(count) {
      if (this.lang === 'zh') {
        return `首单立减$${count}`
      }
      if (this.lang === 'km') {
        return `ទទួលបាន${count}$ក្នុងការបញ្ជាទិញដំបូង`
      }
      return `$${count} Off 1st Order`
    },
    getSpeedDeliveryTitle() {
      if (this.lang === 'zh') {
        return `极速达`
      }
      if (this.lang === 'km') {
        return `ដឹកជញ្ជូនរហ័ស`
      }
      return `Fastest Delivery`
    },
    getFreeDeliveryTitle() {
      if (this.lang === 'zh') {
        return `免配送费`
      }
      if (this.lang === 'km') {
        return `ដឹកជញ្ជូនដោយឥតគិតថ្លៃ`
      }
      return `Free Delivery`
    },
    getFullReductionTitle(m, j) {
      if (this.lang === 'zh') {
        return `满$${m}减$${j}`
      }
      if (this.lang === 'km') {
        return `ទិញ$${m}បញ្ចុះតម្លៃ $${j}`
      }
      return `Buy $${m} Discount $${j}`
    },
    getDiscountTitle(z) {
      if (this.lang === 'zh') {
        return `下单即享${(100 - z) / 10}折`
      }
      if (this.lang === 'km') {
        return `កម្ម៉ង់ឥឡូវនេះ បញ្ចុះតម្លៃ${z}%`
      }
      return `Order Now, Enjoy ${z}% off`
    },
    getPromoteTitle() {
      if (this.lang === 'zh') {
        return '可使用优惠码'
      }
      if (this.lang === 'km') {
        return 'ប្រើប្រូម៉ូកូដ'
      }
      return 'Use promo code'
    },
    loadMore() {
      this.pageSize = this.pageSize + 5
      this.loadList()
    }
  }
}
</script>
<style lang="stylus" scoped>
.store-groupbuy-card {
  width: 294px;
  border-radius: 10px 10px 0px 0px;
  min-height: 274px;
  background: #fff;
  margin: 27px auto 0 auto;
  overflow: hidden;
  position: relative;
  padding-bottom: 10px;
}

.store-groupbuy-card-branch {
  width: 294px;
  height: 145px;
  overflow: hidden;
  text-align: center;
  position: relative;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px 10px 0 0;
}

.store-groupbuy-header-site {
  width: 100%;
  height: 100%;
  position: relative;
}

.store-groupbuy-header-image {
  width: 68px;
  height: 68px;
  background: #fff;
  border: 2px solid #fff;
  border-radius: 50%;
  overflow: hidden;
  top: 110px;
}

.store-groupbuy-header-img {
  border-radius: 50%;
}

.empty-logo {
  width: 100%;
  height: 100%;
  background: #E4E5EA;
  border: 2px solid #fff;
}

.discount_price {
  color: #B5b5b5;
  font-size: 10px;
  margin-left: 10px;
  margin-bottom: 1px;
  font-family: AvenirNext-Regular, AvenirNext;
  font-weight: 400;
  text-decoration: line-through;
  line-height: 13px;
}

.store-groupbuy-header-empty {
  width: 40px;
  height: 40px;
}

.brand-empty-img {
  width: 236px;
}

.product-image {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  margin: 15px 10px 15px 15px;
  vertical-align: middle;
}

.product-info {
  width: 100%;
  background-position: center;
}

.product-name {
  margin-top: 15px;
  max-width: 180px;
  display: inline-block;
  vertical-align: top;
  font-size: 12px;
}

.product-price {
  display: block
  vertical-align: top;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  font-family: AvenirNext-Regular, AvenirNext;
  color: #FC2040;

}

.store-groupbuy-name {
  font-size: 14px;
  font-family: PingFangSC -Regular, sans-serif;
  font-weight: 400;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: wrap;
  line-height: 20px;
  text-align: left;
  margin-top: 50px;
  padding: 0 15px 0 15px;
}

.business-scopes {
  width: 294px;
  margin: 0 auto;
  padding: 3px 0 3px 0;
  text-align: left;
  line-height: 20px;
}

.recommended-product {
  width: 100%
  max-height: 200px;
  overflow-y: scroll;
  position: relative;
  padding: 0 15px 3px 15px;
  margin-top 16px;
  line-height: 20px;
  scrollba-width: none;
}

.recommended-product::-webkit-scrollbar {
  display: none;
}

.business-scopes-item {
  position: relative;
}

.float-right {
  margin-left: 105px;
}

.scopes-img {
  width: 14px;
  height: 15px;
  padding-left: 15px;
}

.business-img {
  background-color: #FEBF01;
  border-radius: 50%;
  top: 10px;
  padding: 0;
  width: 4Px;
  height: 4Px;
  overflow: hidden;
  box-sizing: border-box;
}

.scopes-text {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
  opacity: 0.9;
  padding-left: 9px;
}

.scopes-review {
  padding-left: 31px;

}

.product-item {
  backgroud-size: 150px 50px;
  width: 263px;
  height: 70px;
  //padding: 4px 5px;
  //margin-left: -5px;
  //background: rgba(248, 62, 0, 0.051);
  //border-radius: 10px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  //width: fit-content;
  margin-right: 15px;
  margin-bottom: 10px;
}

.display-middle-flex {
  display: inline-flex;
  vertical-align: middle;
}

.overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.box_show_more {
  text-align: center;

  img {
    width 20px;
    height 20px;
    transform rotate(90deg)
  }
}
</style>
